/**
 * disconnect-downstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateFor, validateTSEnum } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { ResponseCode } from "../general/response-code";
import { MessageTag } from "../message-tag";

/**
 * The server sends a {@link DisconnectDownstreamMessage} to warn an
 * attached client of imminent disconnection.
 */
@validateFor(MessageTag.DOWN_DISCONNECT)
export class DisconnectDownstreamMessage extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DOWN_DISCONNECT;

  @validateTSEnum(ResponseCode)
  public code : ResponseCode;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/disconnect-downstream-message.ts